/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";
import * as stagesCase from "../../Stages/StagesCase";
import { GeneralCivilLaw } from "../../../types/Products/GeneralCivilLaw";

export const generalCivilLawRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (abstractLitigationCase: GeneralCivilLaw) => {
    let requiredFields =
      abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](abstractLitigationCase);

    requiredFields.push("responsibleLawyer");

    return requiredFields;
  },
};
